import { render } from "./ScreenBanner2ColsBP.vue?vue&type=template&id=586eac28&scoped=true&ts=true"
import script from "./ScreenBanner2ColsBP.vue?vue&type=script&lang=ts"
export * from "./ScreenBanner2ColsBP.vue?vue&type=script&lang=ts"

import "./ScreenBanner2ColsBP.vue?vue&type=style&index=0&id=586eac28&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586eac28"]])

export default __exports__